import { AppBar, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { color } from '../../app/theme';
import defaultImageUrl from '../../assets/images/svg/img_avatar_org.svg';
import logo from '../../assets/next/logo/ia-logo.png';
import { saveData } from '../../features/gssVitalSlice';
import Button from '../shared/Button';

const useStyles = makeStyles(
  () => ({
    root: {
      position: 'fixed',
      top: 0,
      color: color.$3,
      height: 80,
      backgroundColor: color.$7,
      boxShadow: 'unset',
      borderBottom: `1px solid ${color.$9}`,
    },
    toolbar: {
      height: 'inherit',
    },
    title: {
      flex: '1 1 auto',
      fontSize: 20,
      margin: '0 0 0 12px',
      display: 'flex',
      alignItems: 'center',
    },
    button: {
      marginRight: 8,
      marginLeft: 4,
    },
    avatar: {
      display: 'flex',
      alignItems: 'flex-end',
    },
    left: {
      display: 'flex',
      alignItems: 'center',
    },
    image: {
      marginLeft: 24,
      borderRadius: 28,
    },
    text: {
      fontSize: 12,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1,
      color: color.$10,
      marginRight: 8,
    },
  }),
  {
    name: 'Header',
  },
);

let image = null;

function Header() {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [imageSrc, setImageSrc] = useState(null);
  const { isLoading } = useSelector(store => store.gssVital);
  const { icon } = useSelector(store => store.organization);
  const { orgId } = useParams();

  const onSave = () => {
    dispatch(saveData(orgId));
  };

  useEffect(() => {
    if (icon && imageSrc !== icon) {
      image = new Image();
      image.onload = () => {
        setImageSrc(image.currentSrc);
      };
      image.src = icon;
    }

    return () => {
      if (image) {
        image.onload = () => {};
      }
    };
  }, [icon, imageSrc]);

  return (
    <AppBar className={classes.root} position="static">
      <Toolbar className={classes.toolbar}>
        <img src={logo} alt="logo" width="32" height="32" />
        <div className={classes.title}>{t('gssVital:title')}</div>
        <div className={classes.avatar}>
          <div className={classes.left}>
            <Button
              className={classes.button}
              topic="primaryGreen"
              onClick={onSave}
              isLoading={isLoading}
            >
              {t('save')}
            </Button>
            <img
              className={classes.image}
              src={imageSrc || defaultImageUrl}
              alt="org-img"
              width={40}
              height={40}
            />
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
